const wowApp = require('angular').module('wowApp.shop');

wowApp.service('CollectionZoneService', ['ShopPageStateService', 'BreakpointsService', 'SettingsService', 'MoveFocus', require('./collection-zone-service.js')]);

wowApp.service('InlineMessageService', ['$templateCache', 'wowCurrencyFilter', '$sce', require('./inline-message-service')]);

wowApp.directive('wowCollectionZone', ['$rootScope', '$timeout', '$sce', 'TrolleyService', 'CollectionZoneService', 'DeliveryService', 'BreakpointsService', 'SettingsService', 'ShopPageStateService', 'ShopperService', 'LoginService', 'AddressService', 'MoveFocus', 'FeatureService', 'StorePickerService', require('./collection-zone-directive')]);

wowApp.directive('wowCollectionZoneItem', ['TrolleyService', 'InlineMessageService', '$timeout', 'MoveFocus', 'SettingsService', 'TrolleySource', 'DecorateAdditionalDetails', 'ShopperService',  require('./collection-zone-item-directive')]);

wowApp.directive('wowCollectionZoneHeader', ['DeliveryService', 'TrolleyService', 'CollectionZoneService', 'ShopperService', 'ShopPageStateService', '$rootScope', '$state', 'SessionContext', 'BreakpointsService', 'PersistentLoginService', 'RouteService', '$ocLazyLoad', 'MoveFocus', 'StorePickerService', require('./collection-zone-header-directive')]);

wowApp.directive('wowCollectionZoneInlineMessage', ['InlineMessageService', require('./inline-message-directive')]);

wowApp.directive('wowSaveTrolleyAsList', ['SettingsService', 'TrolleyService', 'LoginService', 'ShopperService', 'SavedListsService', 'MoveFocus', '$timeout', '$rootScope', '$sanitize', require('./save-trolley-as-list-directive')]);

wowApp.filter('wowCollectionZoneSearch', [require('./collection-zone-search-filter')]);

wowApp.filter('wowCollectionZoneAvailableFilter', [require('./collection-zone-available-filter')]);

wowApp.directive('wowCollectionZoneMessage', [require('./collection-zone-message-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/collectionzone/index.js
 **/